<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <!-- <div class="col-sm-6">
            <h1>Profile Settings</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Profile Settings</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card" id="users-add">
              <div class="overlay" v-if="is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
              <div class="card-body">
                <el-tabs v-model="activeTab" @tab-click="handleTabClick">
                  <!-- Profile Information -->
                  <el-tab-pane label="Profile" name="profile">
                    <form @submit.prevent="handleProfileSubmission()" method="POST" novalidate>
                      <div>
                        <div class="form-row">
                          <div class="form-group col-md-12">
                            <label for="avatar"></label>
                            <div class="row align-items-center">
                              <div class="col-4">
                                <div class="profile-image">
                                  <label class="update-profile-image">
                                    <input :disabled="is_enabled_profile_info" type="file" name="avatar"
                                      class="custom-file-input" id="avatar" @change="selectFile"
                                      accept="image/x-png,image/jpg,image/jpeg" />
                                    <img alt="preview image" v-if="profile.avatar" v-bind:src="profile.avatar"
                                      width="110" height="110" class="img-circle" style="object-fit: cover" />
                                    <span>Change</span>
                                  </label>
                                </div>
                              </div>
                              <div class="col-8">
                                <div class="help text-danger" v-show="errors.has('avatar')">
                                  {{ errors.first("avatar") }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="form-group required col-md-6">
                            <label for="username" class="control-label">Username</label>
                            <input autocomplete="off" type="text" id="username" name="username"
                              v-model="profile.username" v-validate="'required'"
                              :class="{ 'has-error': errors.has('username') }" class="form-control"
                              placeholder="Username" disabled />
                            <div class="help text-danger" v-show="errors.has('username')">
                              {{ errors.first("username") }}
                            </div>
                          </div>

                          <div class="form-group required col-md-6">
                            <label for="first_name" class="control-label">First Name</label>
                            <input type="text" id="first_name" name="first_name" v-model.trim="profile.first_name"
                              v-validate="'required|max:255'" class="form-control"
                              :class="{ 'has-error': errors.has('first_name') }" placeholder="First Name" disabled />
                            <div class="help text-danger" v-show="errors.has('first_name')">
                              {{ errors.first("first_name") }}
                            </div>
                          </div>

                          <div class="form-group col-md-6">
                            <label for="last_name" class="control-label">Last Name</label>
                            <input type="text" id="last_name" name="last_name" v-model.trim="profile.last_name"
                              class="form-control" :class="{ 'has-error': errors.has('last_name') }"
                              placeholder="Last Name" disabled />
                            <div class="help text-danger" v-show="errors.has('last_name')">
                              {{ errors.first("last_name") }}
                            </div>
                          </div>

                          <div class="form-group required col-md-6">
                            <label for="mobile_no" class="control-label">Mobile No.</label>
                            <input :disabled="is_enabled_profile_info" type="text" id="mobile_no" class="form-control"
                              name="mobile_no" placeholder="Mobile No" :class="{ 'has-error': errors.has('mobile_no') }"
                              v-model="profile.mobile_no" v-validate="{
                                required: true,
                                regex:
                                  /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/,
                              }" />
                            <div class="help text-danger" v-show="errors.has('mobile_no')">
                              {{ errors.first("mobile_no") }}
                            </div>
                          </div>

                          <div class="form-group required col-md-12">
                            <label for="email" class="control-label">Email</label>
                            <input type="text" id="email" name="email" v-model="profile.email" class="form-control"
                              :class="{ 'has-error': errors.has('email') }" placeholder="Email"
                              v-validate="'required|email'" data-vv-as="email" disabled />
                            <small class="form-text text-muted mt-2">
                              <i class="fa fa-info-circle"></i>&nbsp;We'll never
                              share your email with anyone else.
                            </small>
                            <div class="help text-danger" v-show="errors.has('email')">
                              {{ errors.first("email") }}
                            </div>
                          </div>

                          <!-- <div class="form-group col-md-12">
                            <label class="checkbox mb-0">
                              <input
                                type="checkbox"
                                name="is_vulnerable"
                                v-model="profile.is_vulnerable"
                                :disabled="is_enabled_profile_info"
                                :checked="
                                  profile.is_vulnerable == 1 ? true : false
                                "
                                @click="toggleVulnerable"
                              />
                              <span class="checkmark"></span>Are you
                              vulnerable?</label
                            >

                            <div
                              class="help text-danger"
                              v-show="errors.has('is_vulnerable')"
                            >
                              {{ errors.first("is_vulnerable") }}
                            </div>
                          </div> -->
                          <div class="form-group col-md-12">
                            <label for="address" class="control-label">Address</label>
                            <textarea disabled id="address" name="address" v-model.trim="profile.address"
                              class="form-control" :class="{ 'has-error': errors.has('address') }"
                              placeholder="Address"></textarea>
                            <div class="help text-danger" v-show="errors.has('address')">
                              {{ errors.first("address") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <button type="submit" v-if="!is_edit" class="btn btn-blue">
                          Submit
                        </button>
                        <button type="submit" class="btn btn-dark-blue" :disabled="is_enabled_profile_info">
                          Update
                        </button>
                        <button @click.prevent="sendCommonOtp('profile_info')" type="button"
                          class="btn btn-dark-blue ml-3">
                          Send OTP
                        </button>
                      </div>
                      <small class="form-text text-muted mt-2">
                        <i class="fa fa-info-circle"></i>&nbsp;To make changes
                        click send OTP to receive your one time passcode!
                      </small>
                    </form>
                  </el-tab-pane>

                  <!-- Password Change Tab  -->
                  <el-tab-pane label="Change Password" name="change_password">
                    <form @submit.prevent="handleUpdatePasswordSubmission()" method="POST" novalidate>
                      <div>
                        <div class="form-row">
                          <div class="form-group required col-md-12">
                            <label for="old_password" class="control-label">Old Password</label>
                            <input autocomplete="off" type="password" id="old_password" name="old_password"
                              v-model="changed_pass.old_password" :class="{
                                'has-error': errors.has('old_password'),
                              }" v-validate="'required'" class="form-control" placeholder="Old password"
                              :disabled="is_enabled_password_change" />
                            <div class="help text-danger" v-show="errors.has('old_password')">
                              {{ errors.first("old_password") }}
                            </div>
                          </div>
                          <div class="form-group required col-md-12">
                            <label for="password" class="control-label">New Password</label>
                            <input autocomplete="off" type="password" id="password" name="password"
                              v-model="changed_pass.password" :class="{ 'has-error': errors.has('password') }"
                              class="form-control" v-validate="{
                                required: true,
                                regex:
                                  /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=]).*$/,
                              }" placeholder="New password" :disabled="is_enabled_password_change" />
                            <span class="help-block">Password should contain at least one captital
                              letter, one small letter, one numeric, one special
                              character <br />
                              and Should be at least 8 characters long</span>
                            <div class="help text-danger" v-show="errors.has('password')">
                              {{ errors.first("password") }}
                            </div>
                          </div>
                          <div class="form-group required col-md-12">
                            <label for="password_confirmation" class="control-label">Confirm Password</label>
                            <input autocomplete="off" type="password" id="password_confirmation"
                              name="password_confirmation" v-model="changed_pass.password_confirmation" v-validate="{
                                required: true,
                                regex:
                                  /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=]).*$/,
                              }" :class="{
                                'has-error': errors.has(
                                  'password_confirmation'
                                ),
                              }" class="form-control" placeholder="Confirm password"
                              :disabled="is_enabled_password_change" />
                            <div class="help text-danger" v-show="errors.has('password_confirmation')">
                              {{ errors.first("password_confirmation") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <button type="submit" class="btn btn-dark-blue" :disabled="is_enabled_password_change">
                          Update Password
                        </button>
                        <button type="button" class="btn btn-dark-blue ml-3"
                          @click.prevent="sendCommonOtp('password_info')">
                          Send OTP
                        </button>
                      </div>
                    </form>
                  </el-tab-pane>
                  <!-- Marketting Information  -->
                  <el-tab-pane label="Marketing Information" name="kci_consent">
                    <form @submit.prevent="handleMarkettingInformation()" method="POST" novalidate>
                      <label class="control-label mb-3">Willing to receive marketing messages via</label>
                      <div class="mb-3">
                        <label class="checkbox">
                          <input @click="toggleSMS" type="checkbox" name="notify_via" v-model="kci_infos.notify_via_sms"
                            :checked="kci_infos.notify_via_sms" :disabled="is_enabled_marketting_info" />
                          <span class="checkmark"></span>SMS</label>

                        <div class="help text-danger" v-show="errors.has('notify_via_sms')">
                          {{ errors.first("notify_via_sms") }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="checkbox">
                          <input @click="toggleEmail" type="checkbox" name="notify_via" :checked="kci_infos.notify_via_email == 1 ? true : false
                            " v-model="kci_infos.notify_via_email" :disabled="is_enabled_marketting_info" />
                          <span class="checkmark"></span>Email</label>
                        <div class="help text-danger" v-show="errors.has('notify_via_email')">
                          {{ errors.first("notify_via_email") }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="checkbox">
                          <input @click="togglePhone" type="checkbox" name="notify_via"
                            :checked="kci_infos.notify_via_phone" v-model="kci_infos.notify_via_phone"
                            :disabled="is_enabled_marketting_info" />
                          <span class="checkmark"></span>Call</label>

                        <div class="help text-danger" v-show="errors.has('notify_via_phone')">
                          {{ errors.first("notify_via_phone") }}
                        </div>
                      </div>

                      <div>
                        <button type="submit" class="btn btn-dark-blue" :disabled="is_enabled_marketting_info">
                          Update
                        </button>
                        <button type="button" class="btn btn-blue ml-3"
                          @click.prevent="sendCommonOtp('marketting_info')">
                          Send OTP
                        </button>
                      </div>
                    </form>
                  </el-tab-pane>

                  <!-- card details  tab start-->
                  <el-tab-pane label="Card Details" name="card_details" 
                  v-if="payment_method === 'STRIPE'"
                  >
                    <!-- <div v-show="payment_method === 'STRIPE'"> -->
                      <form @submit.prevent="updateCardRequest()" method="POST" novalidate>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="alert alert-primary mb-3" role="alert">
                              Card details are protected and cannot be stored
                              without your authorisation. Verification via OTP is
                              required before saving or updating.
                            </div>
                            <div class="form-group required">
                              <label for="card_holder_name" class="control-label">Cardholder Name
                              </label>
                              <input autocomplete="off" :disabled="is_enabled_card_info" type="text"
                                id="card_holder_name" name="card_holder_name" v-model.trim="cardHolderFullName"
                                v-validate="'required|max:150'" :class="{
                                  'has-error': errors.has('card_holder_name'),
                                }" class="form-control" placeholder="Name as it appears on card" />
                              <div class="help text-danger" v-show="errors.has('card_holder_name')">
                                {{
                                  String(
                                    errors.first("card_holder_name")
                                  ).replace("card_holder_name", "Cardholder Name")
                                }}
                              </div>
                            </div>

                            <div class="form-group required">
                              <label for="card_number" class="control-label">Card Number</label>
                              <input type="text" :disabled="is_enabled_card_info" id="card_number" name="card_number"
                                v-model.trim="cardNumber" class="form-control" :class="{
                                  'has-error': errors.has('card_number'),
                                }" placeholder="XXXX XXXX XXXX XXXX" />
                              <div class="help text-danger" v-show="errors.has('card_number')">
                                {{
                                  String(errors.first("card_number")).replace(
                                    "card_number",
                                    "Card Number"
                                  )
                                }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div>
                          <button :disabled="is_enabled_card_info" type="submit" class="btn btn-dark-blue">
                            Update
                          </button>
                          <button type="button" class="btn btn-blue ml-3" @click.prevent="sendCommonOtp('card_info')">
                            Send OTP
                          </button>
                        </div>
                      </form>
                    <!-- </div> -->

                  </el-tab-pane>

                  <!-- Direct Debit Information  -->
                  <el-tab-pane label="Direct Debit Information" name="direct_debit_info"
                     v-if="payment_method === 'GOCARDLESS'"
                    >
                      <form @submit.prevent="handleBankAccountInfo()" method="POST" novalidate>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="alert alert-primary mb-3" role="alert">
                              Update of Following sensitive information is
                              protected by OTP. Use Send OTP button before
                              information update.
                            </div>
                            <div class="form-group required">
                              <label for="bank_account_name" class="control-label">Bank Account Name</label>
                              <input autocomplete="off" :disabled="is_enabled_dd_info" type="text"
                                id="bank_account_name" name="bank_account_name"
                                v-model.trim="bank_info.bank_account_name" v-validate="'required|max:150'" :class="{
                                  'has-error': errors.has('bank_account_name'),
                                }" class="form-control" placeholder="Bank Account Name" />
                              <div class="help text-danger" v-show="errors.has('bank_account_name')">
                                {{
                                  String(
                                    errors.first("bank_account_name")
                                  ).replace(
                                    "bank_account_name",
                                    "Bank Account Name"
                                  )
                                }}
                              </div>
                            </div>

                            <div class="form-group required">
                              <label for="bank_account_number" class="control-label">Account Number</label>
                              <input type="text" :disabled="is_enabled_dd_info" id="bank_account_number"
                                name="bank_account_number" v-on:keyup="removeNonDigit"
                                v-model.trim="bank_info.bank_account_number" v-validate="{
                                  required: true,
                                  max: 8,
                                  regex: /^[0-9]{8}$/,
                                }" class="form-control" :class="{
                                  'has-error': errors.has('bank_account_number'),
                                }" placeholder="Bank Account Number" />
                              <div class="help text-danger" v-show="errors.has('bank_account_number')">
                                {{
                                  String(
                                    errors.first("bank_account_number")
                                  ).replace(
                                    "bank_account_number",
                                    "Account Number"
                                  )
                                }}
                              </div>
                            </div>

                            <div class="form-group required">
                              <label for="bank_sort_code" class="control-label">Sort Code.</label>
                              <input type="text" :disabled="is_enabled_dd_info" id="bank_sort_code"
                                name="bank_sort_code" placeholder="Sort Code" class="form-control" :class="{
                                  'has-error': errors.has('bank_sort_code'),
                                }" v-model.trim="bank_info.bank_sort_code" @keyup="
                                  bank_info.bank_sort_code =
                                  bank_info.bank_sort_code.replace(
                                    /[^0-9]/g,
                                    ''
                                  )
                                  " v-validate="{
                                    required: true,
                                    max: 6,
                                    regex: /^[0-9]{6}$/,
                                  }" />
                              <div class="help text-danger" v-show="errors.has('bank_sort_code')">
                                {{
                                  String(errors.first("bank_sort_code")).replace(
                                    "bank_sort_code",
                                    "Sort Code"
                                  )
                                }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div>
                          <button :disabled="is_enabled_dd_info" type="submit" class="btn btn-dark-blue">
                            Update
                          </button>
                          <button type="button" class="btn btn-blue ml-3" @click.prevent="sendCommonOtp('bank_info')">
                            Send OTP
                          </button>
                        </div>
                      </form>
                  </el-tab-pane>

                </el-tabs>
              </div>
            </div>
          </div>
        </div>

        <!--Modal Begin -->
        <div class="modal fade" id="otp_modal" tabindex="-1" aria-labelledby="otp_modal_label" aria-hidden="true"
          v-if="is_otp_modal_shown">
          <div class="modal-dialog">
            <div class="modal-content">
              <form @submit.prevent="verifyCommonOtp()" method="POST" novalidate>
                <div class="modal-header">
                  <h5 class="modal-title">
                    One Time Password (OTP) Verification
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row text-center flex-row justify-content-center mt-2">
                    Please, Enter the one time password we have sent to your
                    email account.
                  </div>
                  <div class="inputs d-flex flex-row justify-content-center mt-2">
                    <input autocomplete="off" class="m-2 text-center form-control rounded" type="text"
                      :id="'otp_' + index" :name="'otp_' + index" maxlength="1"
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');" v-on:keyup="focusNext($event)"
                      v-for="(elem, index) in otps" :key="'otp_index_' + index" v-model="otps[index]" />
                  </div>
                  <br />
                  <div v-show="!_.isEmpty(otp_validation_message)"
                    class="row text-center flex-row justify-content-center alert alert-danger">
                    {{ otp_validation_message }}
                  </div>
                  <!-- <br /> -->

                  <div class="row">
                    <div class="col-12 text-center">
                      <button class="col-12 text-center btn btn-primary" type="submit">
                        Verify
                      </button>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-12 text-left">
                      <span class="">
                        Didn't Receive a code?
                        <a href="javascript:void(0);" type="button" :disabled="is_resent_disabled"
                          @click.prevent="ResendOtp">
                          Resend
                        </a>
                      </span>
                    </div>

                    <!-- <div class="col-12 text-center"></div> -->
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal" id="modalCloseBtn">
                    Close
                  </button>
                  <!-- <div class="row">
                    <div class="col-md-4"></div>
                  </div> -->
                </div>
              </form>
            </div>
          </div>
        </div>
        <!--Modal End-->
      </div>
    </section>
  </div>
</template>

<style scoped>
input[type="text"][name*="otp"]:focus {
  border-color: #bf2280;
  border-width: 2px;
}

input[type="text"][name*="otp"] {
  font-weight: bolder;
}
</style>

<script>
import { AuthAPI, SelfcareAPI } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "AuthProfile",
  metaInfo: {
    title: `Profile | ${process.env.VUE_APP_COMPANY_NAME}`,
  },
  components: {},
  computed: {
    ...mapGetters(["profile", "accountInfo"]),
    cardHolderFullName: {
      get() {
        return `${this.accountInfo.firstName} ${this.accountInfo.lastName}`;
      },
    },
    cardNumber: {
      get() {
        if (this.accountInfo.card_last_4_digit == null) {
          return "XXXX XXXX XXXX XXXX";
        }
        return "XXXX XXXX XXXX " + this.accountInfo.card_last_4_digit;
      },
    },
  },

  mounted: function () {
    if (this.isMobile()) {
      var sidebarElem = window.$(document).find(".sidebar-mini");
      if ($(sidebarElem).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }
    }

    // if this page load from 'admin/show-card-info' route then 
    // set active tab to card_details
    if (this.$route.path === '/admin/show-card-info') {
      this.activeTab = "card_details";
    }

    // this.payment_method = process.env.VUE_APP_PAYMENT_METHOD;
    console.log("Payment Method::", this.payment_method);
    this.is_enabled_dd_info = true;
    this.errors.clear();
    this.$validator.reset();
    this.getMarkettingInfos();
    this.getBankInfos();
  },

  data: () => ({
    is_edit: true,
    payment_method: process.env.VUE_APP_PAYMENT_METHOD || "STRIPE",
    // console.log("Payment Method:::", payment_method)
    otp_validation_message: "",
    is_enabled_dd_info: true, // means disabled for change
    is_enabled_marketting_info: true, // Marketting Info update enable
    is_enabled_password_change: true,
    is_enabled_profile_info: true,
    is_enabled_card_info: true,

    is_otp_modal_shown: false,
    is_resent_disabled: false,
    changed_pass: {},
    kci_infos: {
      notify_via_sms: false,
      notify_via_email: false,
      notify_via_phone: false,
      is_checked_terms: false,
    },
    bank_info: {
      bank_account_name: "",
      bank_account_number: "",
      bank_sort_code: "",
    },
    is_avatar: false,
    isSelectorLoading: false,
    is_loading: false,
    activeTab: "profile",
    otps: [null, null, null, null, null, null],
    tab_name: "",
    // from https://regexlib.com/
    uk_phone_regex:
      "^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$",
    // profile: {}
  }),
  methods: {
    ...mapActions(["FETCH_PROFILE", "FETCH_ACCOUNT_INFO"]),
    removeNonDigit() {
      this.bank_info.bank_account_number =
        this.bank_info.bank_account_number.replace(/[^0-9]/g, "");
    },
    getBankInfos() {
      const _this = this;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      SelfcareAPI.getBankInfo(subscriber ? subscriber.id : null)
        .then((response) => {
          _this.bank_info = response;
        })
        .catch((errors) => {
          console.log(":::Errors:::", errors.response.data);
        })
        .finally(() => { });
    },
    getMarkettingInfos() {
      const _this = this;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      SelfcareAPI.getMarkettingInfo(subscriber ? subscriber.username : null)
        .then((response) => {
          if (response) {
            // let modifiedResponse;
            for (const [key, value] of Object.entries(response)) {
              //  console.log(`${key}: ${value}`);
              response[key] = value == 1;
            }
            _this.kci_infos = response;
            console.log("::::::Marketting Infos::::", response);
          }
        })
        .catch((errors) => {
          console.log(":::Errors:::", errors.response.data);
        })
        .finally(() => { });
    },
    handleProfileSubmission() {
      const _this = this;
      // _this.tab_name = "verify_otp_for_profile_update";
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      // first_name, mobile_no, email
      _this
        .validateFields(["first_name", "mobile_no", "email"])
        .then((result) => {
          if (result) {
            _this.is_loading = true;
            _this.profile.name = (
              _this.profile.first_name +
              " " +
              _this.profile.last_name
            ).trim();

            if (!_this.is_avatar) {
              _this.$delete(_this.profile, "avatar");
            }

            if (_this.profile.address) _this.$delete(_this.profile, "address");

            _this.profile.subscriber_id = subscriber.id;
            _this.profile.otp_code = _this.otps;
            SelfcareAPI.updateProfileInfo(_this.profile)
              .then((response) => {
                _this.$toaster.success(response.message);
                if (response.code == 200 || response.status == 200) {
                  _this.is_enabled_profile_info = true;
                }
                _this.$forceUpdate();

                //  _this.move({ name: "my-account" });
              })
              .catch((errors) => {
                if (errors.response.status === 500) {
                  _this.$toaster.error(errors.response.data.message);
                }
                _this.$setErrorsFromResponse(errors.response.data);
              })
              .finally(() => {
                _this.FETCH_PROFILE();
                _this.is_avatar = false;
                _this.is_loading = false;
              });
          } else {
            console.log(":::V-validate:::Failed");
          }
        })
        .catch((errors) => { })
        .finally(() => { });
    },

    focusNext(event) {
      console.log("Event::", event);
      const isNumber = /^[0-9]$/i.test(event.key);
      const inputs = Array.from(
        event.target.form.querySelectorAll('input[type="text"]')
      );
      const index = inputs.indexOf(event.target);

      if (isNumber) {
        if (index < inputs.length - 1) {
          inputs[index + 1].focus();
        }
      }
      if (event.key == "Backspace" || event.code == "Backspace") {
        if (index >= 1) {
          inputs[index - 1].focus();
        }
      }
    },

    toggleVulnerable() {
      console.log(":::toggleVulnerable Clicked:::");
      this.profile.is_vulnerable = this.profile.is_vulnerable == 1 ? 0 : 1;
      console.log(":::is_vulnerable:::", this.profile.is_vulnerable);
      this.$nextTick(() => { });
      this.$forceUpdate();
    },
    togglePhone() {
      console.log("Phone value Clicked:");
      this.kci_infos.notify_via_phone = !this.kci_infos.notify_via_phone;
      this.$nextTick(() => { });
      this.$forceUpdate();
    },

    toggleEmail() {
      console.log("Email value Clicked:");
      this.kci_infos.notify_via_email = !this.kci_infos.notify_via_email;
      this.$nextTick(() => { });
      this.$forceUpdate();
    },

    toggleSMS() {
      console.log("SMS value Clicked:");
      this.kci_infos.notify_via_sms = !this.kci_infos.notify_via_sms;
      this.$nextTick(() => { });
      this.$forceUpdate();
    },

    verifyCommonOtp() {
      const _this = this;
      let subscriber;
      console.log("Otp Array::", this.otps);
      subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        SelfcareAPI.verifyCommonOtp({ otp_code: this.otps, id: subscriber.id })
          .then((response) => {
            _this.$toaster.success(response.message);
            if (response.code === 200 || response.status === 200) {
              if (_this.tab_name == "bank_info") {
                _this.is_enabled_dd_info = false;
              }
              if (_this.tab_name == "marketting_info") {
                _this.is_enabled_marketting_info = false;
              }
              if (_this.tab_name == "password_info") {
                _this.is_enabled_password_change = false;
              }

              if (_this.tab_name == "profile_info") {
                _this.is_enabled_profile_info = false;
              }
              if (_this.tab_name == "card_info") {
                _this.is_enabled_card_info = false;
              }

              console.log("::::::_this.tab_name == ", _this.tab_name);

              _this.$nextTick(() => {
                _this.is_otp_modal_shown = false;
                $("#modalCloseBtn").click();
                $("#otp_modal").modal("hide");
              });
              _this.$forceUpdate();
            }
          })
          .catch((errors) => {
            console.log("::::Errors:::", errors.response.data);
            console.log("::::Errors:::", errors);
            let errorMessage = "";
            const errorObject = errors.response.data;
            if (errorObject.hasOwnProperty("errors")) {
              console.log("::::errors property exist:::", errorObject.errors);
            }
            if (errorObject) {
              errorMessage = errorObject?.errors?.otp_code;
            }

            _this.otp_validation_message = errorMessage;
            console.log("::::Error Message:::", errorMessage);
            _this.$forceUpdate();
          })
          .finally(() => { });
      }
    },

    ResendOtp() {
      const _this = this;
      let subscriber;
      _this.is_resent_disabled = true;
      subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      _this.is_loading = true;
      console.log("Resent Clicked");
      SelfcareAPI.sendCommonOtpRequest(subscriber.id)
        .then((response) => {
          _this.is_loading = false;
          _this.$toaster.success(response.message);
        })
        .catch((error) => {
          _this.is_loading = false;
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },

    sendCommonOtp(tabInfo) {
      const _this = this;
      let subscriber;
      _this.otps = [null, null, null, null, null, null];
      subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      _this.is_loading = true;
      if (subscriber) {
        if (tabInfo == "bank_info") _this.tab_name = "bank_info";

        if (tabInfo == "marketting_info") {
          _this.tab_name = "marketting_info";
        }

        if (tabInfo == "password_info") {
          _this.tab_name = "password_info";
        }
        if (tabInfo == "profile_info") {
          _this.tab_name = "profile_info";
        }
        if (tabInfo == "card_info") {
          _this.tab_name = "card_info";
        }

        //

        SelfcareAPI.sendCommonOtpRequest(subscriber.id)
          .then((response) => {
            _this.is_loading = false;
            _this.$toaster.success(response.message);
            if (response.status) {
              _this.is_otp_modal_shown = true;
              _this.$nextTick(() => {
                $("#otp_modal").modal("show");
              });
              _this.$forceUpdate();
            }
          })
          .catch((error) => {
            _this.is_loading = false;
          })
          .finally(() => {
            _this.is_loading = false;
          });
      }
    },

    handleBankAccountInfo() {
      const _this = this;
      console.log("::::bank_info Information::::", this.bank_info);
      // console.log("::::is_otp_modal_shown::::", this.is_otp_modal_shown);
      _this.tab_name = "bank_info";
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);

      this.validateFields([
        "bank_account_name",
        "bank_account_number",
        "bank_sort_code",
      ]).then((result) => {
        if (result) {
          _this.is_loading = true;
          let payload = _this.bank_info;
          payload.id = subscriber.id;
          payload.otp_code = _this.otps;
          SelfcareAPI.initBankInfoUpdate(payload)
            .then((response) => {
              _this.$toaster.success(response.message);
              if (response.code == 200 || response.status == 200) {
                _this.is_enabled_dd_info = true;
              }
              _this.getBankInfos();
              _this.$forceUpdate();
            })
            .catch((errors) => {
              _this.is_loading = false;
              console.log(":::Error Response:::", errors.response.data);
              //_this.$toaster.error(errors.response.data);
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },

    updateCardRequest() {
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        //download_agreement
        axios
          .get("update-card-request", {
            params: {
              cuid: subscriber.id,
            },
          })
          .then((response) => {
            if (response.data.status) {
              const redirectLink = `${response.data.update_url}`;
              window.location.href = redirectLink;
            } else {
              this.$toaster.error(`${response.data.message}`);
            }
          })
          .catch((error) => {
            this.$toaster.error(
              "Something went wrong!. Please, contact with system administrator."
            );
          });
      }
    },

    handleBankAccountInfo() {
      const _this = this;
      console.log("::::bank_info Information::::", this.bank_info);
      // console.log("::::is_otp_modal_shown::::", this.is_otp_modal_shown);
      _this.tab_name = "bank_info";
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);

      this.validateFields([
        "bank_account_name",
        "bank_account_number",
        "bank_sort_code",
      ]).then((result) => {
        if (result) {
          _this.is_loading = true;
          const payload = _this.bank_info;
          payload.id = subscriber.id;
          payload.otp_code = _this.otps;
          SelfcareAPI.initBankInfoUpdate(payload)
            .then((response) => {
              _this.$toaster.success(response.message);
              if (response.code == 200 || response.status == 200) {
                _this.is_enabled_dd_info = true;
              }
              _this.getBankInfos();
              _this.$forceUpdate();
            })
            .catch((errors) => {
              _this.is_loading = false;
              console.log(":::Error Response:::", errors.response.data);
              // _this.$toaster.error(errors.response.data);
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },

    handleMarkettingInformation() {
      const _this = this;
      const payload = {
        ...this.kci_infos,
      };
      payload.notify_via_email = payload.notify_via_email ? 1 : 0;
      payload.notify_via_phone = payload.notify_via_phone ? 1 : 0;
      payload.notify_via_sms = payload.notify_via_sms ? 1 : 0;

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      payload.id = subscriber.id;
      payload.otp_code = _this.otps;

      // _this.tab_name = "verify_otp";
      _this.is_loading = true;
      SelfcareAPI.initMarkettingInfoUpdate(payload)
        .then((response) => {
          _this.$toaster.success(response.message);
          if (response.code == 200 || response.status == 200) {
            _this.is_enabled_marketting_info = true; // means disable password fields after success
          }
          _this.getMarkettingInfos();
          _this.$forceUpdate();
        })
        .catch((errors) => {
          _this.is_loading = false;
          console.log(":::Error Response:::", errors.response.data);
          _this.$toaster.error(errors.response.data);
          _this.$setErrorsFromResponse(errors.response.data);
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },

    validateFields(fieldNames) {
      const fieldValidationPromises = [];

      fieldNames.forEach((fieldName) => {
        const promise = this.$validator.validate(fieldName);
        fieldValidationPromises.push(promise);
      });

      return Promise.all(fieldValidationPromises)
        .then((results) => {
          if (results.includes(false)) {
            return false;
          } else {
            return true;
          }
        })
        .catch((error) => {
          console.error("Validation error:", error);
          return false;
        });
    },

    handleUpdatePasswordSubmission() {
      console.log("Password Change Called");
      //  this.tab_name = "auth/verify_otp_for_change_password";
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      const payload = this.changed_pass;
      payload.otp_code = this.otps;
      payload.id = subscriber.id;

      this.validateFields([
        "old_password",
        "password",
        "password_confirmation",
      ]).then((result) => {
        if (result) {
          this.is_loading = true;
          AuthAPI.changePassword(payload)
            .then((response) => {
              this.errors.clear();
              this.$toaster.success(response.message);
              if (response.code == 200) {
                this.is_enabled_password_change = true; // means disable password fields after success
              }
              this.$forceUpdate();
            })
            .catch((errors) => {
              this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              this.changed_pass = {};
              this.is_loading = false;
            });
        }
      });
    },
    selectFile: function (event) {
      // `files` is always an array because the file input may be in multiple mode
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.is_avatar = true;
        this.profile.avatar = reader.result;
      };
    },
    move(params) {
      // get comparable fullPaths
      const from = this.$route.fullPath;
      const to = this.$router.resolve(params).route.fullPath;

      if (from === to) {
        // handle any error due the redundant navigation here
        // or handle any other param modification and route afterwards
        return;
      }
      this.$router.push(params);
    },
    handleTabClick(tab, event) {
      console.log("Tab::", tab, "::Event::", event);
    },
  },
};
</script>
